import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { TomaInventario } from '../types/toma.types';

interface TomaInventarioStore {
  tomas: TomaInventario[];
  loading: boolean;
  setTomas: (tomas: TomaInventario[]) => void;
  setLoading: (loading: boolean) => void;
}

export const useTomaInventarioStore = create<TomaInventarioStore>()(
  devtools(
    (set) => ({
      tomas: [],
      loading: false,
      setTomas: (tomas) => set({ tomas }),
      setLoading: (loading) => set({ loading }),
    }),
    { name: 'TomaInventarioStore' }
  )
);
